import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useMediaQuery } from "@mui/material";
import Fade from "@mui/material/Fade";
import Tooltip from "@mui/material/Tooltip";
import { useIsClient } from "@uidotdev/usehooks";
import { Fragment, useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useSpring } from "react-spring";
import { bindActionCreators } from "redux";
import * as config from "../../../config/config";
import {
  clearCompanyList,
  getCompanyPageBanner,
  updateStateRegions,
} from "../../../redux/actions/company_action";
import { store } from "../../../redux/stores/store";
import {
  ContainerStyled,
  FilterSubtitle,
  GridCompanyLogo,
  GridContainer,
  GridContainerInner,
  GridFilterContainer,
  GridFilters,
  GridLogoContainer,
  GridPlayButtonContainer,
  GridTitle,
  IconButtonStyled,
  ImageStyled,
  ReactPlayerStyled,
  TitleStyled,
} from "./styles";

let loopCompanyNameInterval;
let fetchIndustryCount = 0;
let fetchStateRegionCount = 0;
let companyNameIndex = 1;
let useCurrentCompanyName = true;

/*
 * 1) Will call graphQL to get company industries
 * 2) Will call graphQL to get state region here
 */
function CompanySearchFilters(props) {
  const isMobile = useMediaQuery("(max-width: 640px)");

  const isClient = useIsClient();

  const showFilter = useSelector((state: any) => state.navbar.showFilter);
  const [playing, setPlaying] = useState(true);
  const [currentCompanyName, setCurrentCompanyName] =
    useState("Shopline Malaysia");
  const companyNames = [
    "Shopline Malaysia",
    "Lazada Malaysia",
    "VF Corporation",
    "Ninja Van",
    "AIA BHD",
    "Hiredly.Com",
  ];

  const fetchIndustryTries = 5;
  const fetchStateRegionTries = 5;

  useEffect(() => {
    setCompanyNameLoopInterval();
    return () => {
      clearCompanyNameLoopInterval();
    };
  }, []);

  function setCompanyNameLoopInterval() {
    if (store.getState().companies.companyFilter["keyword"]) {
      useCurrentCompanyName = false;
      return;
    }

    clearCompanyNameLoopInterval();

    // Set loop company name interval
    loopCompanyNameInterval = setInterval(loopThroughCompanyName, 5000);
  }

  function clearCompanyNameLoopInterval() {
    // Clear interval
    if (loopCompanyNameInterval) {
      clearInterval(loopCompanyNameInterval);
    }
  }

  function loopThroughCompanyName() {
    let index = companyNameIndex % 4;

    let companyName = companyNames[index];

    setCurrentCompanyName(companyName);

    companyNameIndex++;

    if (companyNameIndex > 10000000) {
      companyNameIndex = 0;
    }
  }

  function handleClick() {
    setPlaying(!playing);
  }

  // For auto-scroll on click Discover Now
  const playerRef = useRef(null);

  const dispatch = useDispatch();
  const companyBanner = useSelector(
    (state: any) => state.companies.companyPageBanner
  );

  // React Spring animation for title text
  const titleAnimateFirst = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    delay: 700,
    config: { duration: 1000 },
  });

  function getVideoUrl() {
    if (isMobile) {
      return `${config.assetDomain}/images/landing/featured_company_banner/jobs_malaysia_celcomdigi_video_banner_mobile.mp4`;
    } else {
      return `${config.assetDomain}/images/landing/featured_company_banner/jobs_malaysia_celcomdigi_video_banner.mp4`;
    }
  }

  const videoUrl = getVideoUrl();

  const companyUrl = "";
  async function getBanner() {
    // TODO: resolve TypeScript error
    // @ts-ignore
    dispatch(getCompanyPageBanner());
  }

  useEffect(() => {
    getBanner();
  }, [dispatch]);

  return isClient ? (
    <Fragment>
      <ContainerStyled
        style={showFilter ? { marginTop: 100 } : { marginTop: 0 }}
        ref={playerRef}
      >
        <ReactPlayerStyled
          url={videoUrl}
          playing={playing}
          loop={true}
          muted={true}
          width="100%"
          height="100%"
          style={{
            maxHeight: "700px",
            overflow: "hidden",
          }}
        />
        <GridFilters>
          <GridFilterContainer>
            <GridTitle>
              <TitleStyled style={titleAnimateFirst} variant="h1">
                {companyBanner.title ?? "Discover your future company"}
              </TitleStyled>
            </GridTitle>
            <GridContainer>
              <GridContainerInner>
                <FilterSubtitle textAlign={"center"}>
                  {companyBanner.description}
                </FilterSubtitle>
              </GridContainerInner>
            </GridContainer>
          </GridFilterContainer>
          <GridCompanyLogo>
            <a href={"https://my.hiredly.com/companies/celcomdigi"}>
              <Tooltip
                title="Click to View Company Profile"
                placement={"top"}
                arrow
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 400 }}
              >
                <GridLogoContainer id={"company-logo-button"}>
                  <ImageStyled
                    src={
                      "https://resources.wobbjobs.com/jobs-malaysia/companies/84467d14-0298-4736-be37-62b25903e966/company_logo/original/d72a8756-ddc1-4cdb-b044-cb01935df91d-230907_CelcomDigi-Logo_for-NavyBlue-background_RGB.png"
                    }
                    alt="company-logo"
                  />
                </GridLogoContainer>
              </Tooltip>
            </a>
            <GridPlayButtonContainer>
              <IconButtonStyled
                id={"video-play-pause-button"}
                aria-label="video-play-pause"
                onClick={handleClick}
                // TODO: resolve TypeScript error
                // @ts-ignore
                fontSize="large"
              >
                {playing ? <PauseIcon /> : <PlayArrowIcon />}
              </IconButtonStyled>
            </GridPlayButtonContainer>
          </GridCompanyLogo>
        </GridFilters>
      </ContainerStyled>
    </Fragment>
  ) : null;
}

const mapStateToProps = (state) => {
  return {
    industries: state.companies.industries,
    companyFilter: state.companies.companyFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearCompanyList: bindActionCreators(clearCompanyList, dispatch),
    updateStateRegions: bindActionCreators(updateStateRegions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanySearchFilters);
